<template>
    <v-container id="home" fluid fill-height home-hero h100>
        <v-layout justify-center align-center column>
            <h1 style="display: none">Northland Flooring Specialist</h1>
            <div class="hidden-sm-and-down" pa-5>

                <div class="myFont display-4 font-weight-black white--text text-xs-center">
                    <img src="/images/app-icons/apple-icon.png" width="100" style="vertical-align: text-bottom"></img>{{this.$myApp.customer.name}}
                </div>
                <div class="display-2 font-weight-black white--text text-xs-center mb-3">
                    Flooring specialist
                </div>
                <div class="display-1 font-weight-bold white--text text-xs-center">
                    For the highest quality floor preparation and finishing
                </div>
            </div>
            <div class="hidden-md-and-up" pa-1>

                <div class="myFont display-3 font-weight-black white--text text-xs-center">
                    <img  text-xs-center src="/images/app-icons/apple-icon.png" width="100"/><br>
                    {{this.$myApp.customer.name}}

                </div>
                <div class="display-1 font-weight-black white--text text-xs-center mb-3">
                    Flooring specialist
                </div>
                <div class="title font-weight-bold white--text text-xs-center">
                    For the highest quality floor preparation and finishing
                </div>
            </div>
            <v-btn fab class="mt-5 brown darken-4">
                <scrollactive class="my-nav">
                    <a href="#details" class="none scrollactive-item"><v-icon large color="white">fas fa-angle-down</v-icon></a>
                </scrollactive>
            </v-btn>
        </v-layout>
    </v-container>
</template>

<script>
    //console.log(this.$myApp.customer.name);
export default {
    name: 'HomeHero'
};
</script>

<style scoped>
    @import url('https://fonts.googleapis.com/css?family=ZCOOL+XiaoWei');
    .home-hero {
        text-shadow: 3px 2px #524e4e;
        background-image: url('~@/assets/home.jpg');
        background-size: cover;
        width: 100%;
        height: 100%;
    }
    .myFont{
        font-family:'ZCOOL XiaoWei', serif !important
    }
</style>
